import {createBrowserRouter, Navigate, RouterProvider} from 'react-router';
import {Landing} from './pages/Landing';
import {Dashboard} from './pages/Dashboard';
import {Admin} from './pages/Admin';
import {ContentUpload} from './pages/ContentUpload';
import {CustomUpload} from './pages/CustomUpload';
import {TestUpload} from './pages/TestUpload';
import {ProtectedRoute} from './components/ProtectedRoute';
import {AdminRoute} from './components/AdminRoute';

const router = createBrowserRouter([
  {path: '/', element: <Landing />},
  {
    path: '/app',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin',
    element: (
      <AdminRoute>
        <Admin />
      </AdminRoute>
    ),
  },
  // Token-auth: сесія не потрібна, доступ тільки за валідною парою
  // (customRequestId, token). Перевірка — на бекенді.
  {path: '/custom-upload', element: <CustomUpload />},
  // Content-requests — паралельна підсистема. Те саме token-auth, інший
  // resource: пара (contentRequestId, token).
  {path: '/content-upload', element: <ContentUpload />},
  // TEMP: публічний аплоадер без авторизації, ллє у спільну папку TEST.
  // Видалити разом з POST /api/_test/upload коли тимчасова потреба зникне.
  {path: '/test', element: <TestUpload />},
  {path: '*', element: <Navigate to="/" replace />},
]);

export function App() {
  return <RouterProvider router={router} />;
}
